import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aqar23-profile',
  templateUrl: './aqar23-profile.component.html',
  styleUrls: ['./aqar23-profile.component.scss']
})
export class Aqar23ProfileComponent implements OnInit {
  src: string ='/assets/pdf/NAAC/AQAR/ACADEMIC CALENDAR 2023-24.pdf';
  constructor() { }

  ngOnInit(): void {
  }

}
